import { useTranslation } from 'react-i18next';

import { ModalShell } from '../../../components';

/**
 * 노래 진단 전 이어폰 권장 — 직전 테이크가 스피커 경로였을 때만 뜬다(`isSpeakerRoute`).
 *
 * 권장이지 게이트가 아니다: 닫으면 그대로 스피커로 진행한다. 배경·Esc 도 같은 닫기다.
 */
export const HeadphoneAdvice = ({ onClose }: { onClose: () => void }) => {
  const { t } = useTranslation();
  return (
    <ModalShell
      labelledBy="headphone-advice-title"
      dismissLabel={t('web.diagnosis.song.headphoneAdvice.confirm')}
      onDismiss={onClose}
      className="px-5 pb-5 pt-8"
    >
      <h2
        id="headphone-advice-title"
        className="text-lg font-semibold tracking-[-0.18px] text-bk-900"
      >
        {t('web.diagnosis.song.headphoneAdvice.title')}
      </h2>
      <p className="mt-2 whitespace-pre-line break-keep text-sm leading-relaxed text-bk-600">
        {t('web.diagnosis.song.headphoneAdvice.body')}
      </p>
      <button
        type="button"
        autoFocus
        onClick={onClose}
        className="mt-6 h-[54px] w-full rounded-full bg-bk-900 text-base font-semibold text-white"
      >
        {t('web.diagnosis.song.headphoneAdvice.confirm')}
      </button>
    </ModalShell>
  );
};
